module.exports = __webpack_public_path__ + "static/media/banner.291eba83.jpg";